import React, { Fragment } from 'react';
import T from 'prop-types';

import UserReportForm from '../../../shared/components/UserReportForm';
import Modal from '../../../../../../components/Modal';

const UserReportFormModal = ({
  show,
  sitekey,
  isProcessing,
  customErrors,
  setProcessing,
  onSubmit,
  onHide,
}) => (
  <Modal
    open={show}
    size="xs"
    hideCloseButton
    shouldCloseOnOverlayClick={false}
    modalClassName="report-preview-user-form-modal"
    onClose={() => onHide(false)}
  >
    {show && (
      <Fragment>
        <header className="report-preview-user-form-modal__header">
          <p className="report-preview-user-form-modal__header-title">Get Your Market Report</p>
          <span className="hicon-close" onClick={() => onHide(false)} />
        </header>
        <UserReportForm
          sitekey={sitekey}
          isProcessing={isProcessing}
          customErrors={customErrors}
          submitButtonText="Send My Report"
          className="report-preview__user-form"
          setProcessing={setProcessing}
          onSubmit={onSubmit}
        />
      </Fragment>
    )}
  </Modal>
);

UserReportFormModal.propTypes = {
  show: T.bool.isRequired,
  sitekey: T.string,
  isProcessing: T.bool.isRequired,
  customErrors: T.object.isRequired,
  setProcessing: T.func.isRequired,
  onSubmit: T.func.isRequired,
  onHide: T.func.isRequired,
};

export default UserReportFormModal;
